import script from "./QTLiteResizeOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteResizeOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteResizeOverlay.vue?vue&type=style&index=0&id=e7b072d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7b072d8"]])

export default __exports__